import { render, staticRenderFns } from "./TableManagers.vue?vue&type=template&id=7a60db58&"
import script from "./TableManagers.vue?vue&type=script&lang=js&"
export * from "./TableManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a60db58')) {
      api.createRecord('7a60db58', component.options)
    } else {
      api.reload('7a60db58', component.options)
    }
    module.hot.accept("./TableManagers.vue?vue&type=template&id=7a60db58&", function () {
      api.rerender('7a60db58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableManagers.vue"
export default component.exports